export default __webpack_public_path__ + "e81cd3ef1cf9c371521c23c84e58779b.svg";